import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Injector } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-cancel-subscription-dialog-content',
  templateUrl: './cancel-subscription-dialog-content.component.html',
  styleUrls: ['./cancel-subscription-dialog-content.component.scss']
})
export class CancelSubscriptionDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'CancelSubscriptionDialogContentComponent';

  constructor(
    public activeModal: NgbActiveModal,
    injector: Injector) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  onConfirm() {
    this.activeModal.close({ confirmed: true });
  }

}
